<template>
  <div style="height: 100%; width: 100%">
    <iframe
      v-if="inProd"
      @load="onLoadHandler"
      style="height: 100vh; width: 100%"
      ref="catchAll"
      :src="iframeUrl"
    ></iframe>
    <div v-else style="padding-left: 50px">In production, I would have tried to show {{ iframeUrl }} here.</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: null,
      iframeUrl: '',
    };
  },
  computed: {
    inProd() {
      return process.env.NODE_ENV === 'production';
    },
  },

  methods: {
    onLoadHandler() {
      const iframe = this.$refs.catchAll;
      if (iframe.innerHTML) {
        console.log('Title: ', iframe.contentDocument.title);
        this.$raven.captureException(new Error('Iframe 404: ' + this.iframeUrl));
      }
    },
  },
  mounted() {
    const vue = this;
    const url = new URL(window.location);
    url.pathName = vue.$route.params.pathMatch;
    url.pathname = url.pathname.replace('dashboard', 'vintageboard');

    // If we match the enrich url in the dashboard, load the /enrich-rental-object/ in the iframe
    const enrichMatch = url.pathname.match(/\/landlord\/(\d+)\/rentalObject\/(\d+)\/enrich/);
    if (enrichMatch) {
      let newPathname = '/enrich-rental-object/' + enrichMatch[1] + '/rental-object/' + enrichMatch[2] + '/search';
      url.pathname = newPathname;
    }

    vue.iframeUrl = url.href;

    if (this.inProd) {
      vue.timer = setInterval(() => {
        if ('catchAll' in vue.$refs && 'contentWindow' in vue.$refs.catchAll) {
          const url = new URL(vue.$refs.catchAll.contentWindow.location.href);
          const currUrl = new URL(window.location.href);
          const oldPath = currUrl.pathname;
          let newPath = url.pathname.replace('vintageboard', 'dashboard');

          if (oldPath !== newPath && !url.pathname.match('/enrich')) {
            if (this.$router.options.base !== '/') {
              newPath = newPath.replace(this.$router.options.base, '/');
            }

            vue.$router.push({ path: newPath });
          }
        } else {
          console.log('no ref in prod?', process.env.NODE_ENV);
        }
      }, 250);
    }
  },

  beforeDestroy() {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>
